import { billing } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  GET_ALL_INVOICES,
  GET_ALL_INVOICES_START,
  GET_ALL_INVOICES_COMPLETE,
  GET_ALL_INVOICES_ERROR,
  DOWNLOAD_REPORT,
  DOWNLOAD_REPORT_START,
  DOWNLOAD_REPORT_COMPLETE,
  DOWNLOAD_REPORT_ERROR,
  DOWNLOAD_INVOICE,
  DOWNLOAD_INVOICE_START,
  DOWNLOAD_INVOICE_COMPLETE,
  DOWNLOAD_INVOICE_ERROR,
  MAKE_MONTHLY_PAYMENT,
  MAKE_MONTHLY_PAYMENT_START,
  MAKE_MONTHLY_PAYMENT_COMPLETE,
  MAKE_MONTHLY_PAYMENT_ERROR,
  FETCH_ALL_PAYMENT_TRANSACTIONS,
  FETCH_ALL_PAYMENT_TRANSACTIONS_START,
  FETCH_ALL_PAYMENT_TRANSACTIONS_COMPLETE,
  FETCH_ALL_PAYMENT_TRANSACTIONS_ERROR,
  ADD_FUNDS_TO_BANK,
  ADD_FUNDS_TO_BANK_START,
  ADD_FUNDS_TO_BANK_COMPLETE,
  ADD_FUNDS_TO_BANK_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setUserStatusUnauthorised } from '../userProfile/actions';

export function* getAllInvoices({ payload: { params } }) {
  try {
    yield put({
      type: GET_ALL_INVOICES_START,
    });
    const { response, error } = yield call(billing.getAllInvoices, {
      params,
    });

    if (!!response) {
      yield put({
        type: GET_ALL_INVOICES_COMPLETE,
        payload: {
          data: response.data,
          totalPages: response.total_pages,
          totalRecords: response.total_records,
        },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetAllInvoicesError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetAllInvoicesError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* fetchAllPaymentTransactions({ payload: { params } }) {
  try {
    yield put({
      type: FETCH_ALL_PAYMENT_TRANSACTIONS_START,
    });
    const { response, error } = yield call(billing.fetchAllPaymentTransactions, {
      params,
    });

    if (!!response) {
      yield put({
        type: FETCH_ALL_PAYMENT_TRANSACTIONS_COMPLETE,
        payload: {
          data: response.transactions,
          totalRecords: response.total_records,
        },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onFetchAllPaymentTransactionsError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onFetchAllPaymentTransactionsError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* downloadReport({ payload: { id, agency } }) {
  try {
    yield put({
      type: DOWNLOAD_REPORT_START,
    });
    const { response, error, headers } = yield call(billing.downloadReport, {
      id,
      agency,
    });

    if (!!response) {
      const contentDisposition = headers['content-disposition'];
      let fileName = 'downloaded-file.pdf'; // Fallback file name

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      const url = window.URL.createObjectURL(new Blob([response]));

      // Create a temporary <a> element
      const link = document.createElement('a');
      link.href = url;

      // Set the file name (you can make it dynamic)
      link.setAttribute('download', fileName);

      // Append to document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      yield put({
        type: DOWNLOAD_REPORT_COMPLETE,
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onDownloadReportError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onDownloadReportError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* downloadInvoice({ payload: { id, agency } }) {
  try {
    yield put({
      type: DOWNLOAD_INVOICE_START,
    });
    const { response, error, headers } = yield call(billing.downloadInvoice, {
      id,
      agency,
    });

    if (!!response) {
      const contentDisposition = headers['content-disposition'];
      let fileName = 'downloaded-file.pdf'; // Fallback file name

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }

      const url = window.URL.createObjectURL(new Blob([response]));

      // Create a temporary <a> element
      const link = document.createElement('a');
      link.href = url;

      // Set the file name (you can make it dynamic)
      link.setAttribute('download', fileName);

      // Append to document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      yield put({
        type: DOWNLOAD_INVOICE_COMPLETE,
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onDownloadInvoiceError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onDownloadInvoiceError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* makeMonthlyPayment({ payload: { params } }) {
  try {
    yield put({
      type: MAKE_MONTHLY_PAYMENT_START,
    });
    const { response, error } = yield call(billing.makeMonthlyPayment, {
      params,
    });
    if (!!response) {
      yield put({
        type: MAKE_MONTHLY_PAYMENT_COMPLETE,
        payload: {
          data: response.checkout_url,
        },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onMakeMonthlyPaymentError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onMakeMonthlyPaymentError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* addFundsToBank({ payload: { params } }) {
  try {
    yield put({
      type: ADD_FUNDS_TO_BANK_START,
    });
    const { response, error } = yield call(billing.addFundsToBank, {
      params,
    });

    // yield delay(5000);
    // const error = '';
    // const response = {
    //   checkout_url:
    //     'https://checkout.stripe.com/c/pay/cs_test_a1DVnv1QDtIGeIrzns697h49qwtoEbmN6zTa4oFA6gIa9qI6DfX1jPQ8eM#fidkdWxOYHwnPyd1blpxYHZxWjA0S21zdjxMdkhMRGsxNV9LbG1LSkRvVm81azxuMEI9VTFxSkozYjdRYzNuXT1vcU1WXUE8TmRgNGxkXFBfUFVWUXVMc2BccndCbUZUf2dmfVJjbzd3dlR3NTVKdXNUT3JBdCcpJ2N3amhWYHdzYHcnP3F3cGApJ2lkfGpwcVF8dWAnPyd2bGtiaWBabHFgaCcpJ2BrZGdpYFVpZGZgbWppYWB3dic%2FcXdwYHgl',
    // };
    if (!!response) {
      yield put({
        type: ADD_FUNDS_TO_BANK_COMPLETE,
        payload: {
          data: response.checkout_url,
        },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onAddFundsToBankError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onAddFundsToBankError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onAddFundsToBankError = (payload = {}) => ({
  type: ADD_FUNDS_TO_BANK_ERROR,
  payload,
});

const onFetchAllPaymentTransactionsError = (payload = {}) => ({
  type: FETCH_ALL_PAYMENT_TRANSACTIONS_ERROR,
  payload,
});

const onMakeMonthlyPaymentError = (payload = {}) => ({
  type: MAKE_MONTHLY_PAYMENT_ERROR,
  payload,
});

const onGetAllInvoicesError = (payload = {}) => ({
  type: GET_ALL_INVOICES_ERROR,
  payload,
});

const onDownloadReportError = (payload = {}) => ({
  type: DOWNLOAD_REPORT_ERROR,
  payload,
});

const onDownloadInvoiceError = (payload = {}) => ({
  type: DOWNLOAD_INVOICE_ERROR,
  payload,
});

function* watchFetchAllPaymentTransactions() {
  yield takeLatest(FETCH_ALL_PAYMENT_TRANSACTIONS, fetchAllPaymentTransactions);
}

function* watchAddFundsToBank() {
  yield takeLatest(ADD_FUNDS_TO_BANK, addFundsToBank);
}

function* watchMakeMonthlyPayment() {
  yield takeLatest(MAKE_MONTHLY_PAYMENT, makeMonthlyPayment);
}

function* watchGetAllInvoices() {
  yield takeLatest(GET_ALL_INVOICES, getAllInvoices);
}

function* watchDownloadReport() {
  yield takeLatest(DOWNLOAD_REPORT, downloadReport);
}

function* watchDownloadInvoice() {
  yield takeLatest(DOWNLOAD_INVOICE, downloadInvoice);
}

export const sagas = [
  watchGetAllInvoices,
  watchDownloadReport,
  watchDownloadInvoice,
  watchMakeMonthlyPayment,
  watchFetchAllPaymentTransactions,
  watchAddFundsToBank,
];
